import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {CommunitiesService} from '../_services/communities.service';
import {ContentService} from '../_services/content.service';
import {map} from 'rxjs';

export const emailVerifiedGuard: CanActivateFn = (route, state) => {
    const router: Router = inject(Router);
    const communitiesService: CommunitiesService = inject(CommunitiesService);
    const contentService: ContentService = inject(ContentService);

    return contentService.getCurrentDashboardCommunity().pipe(
        map(community => {
            if (!community) {
                return true;
            }

            if ((communitiesService.emailVerified as boolean | undefined) !== false) {
                return true;
            }

            router.navigate(['/verify']).then();
            return false;
        })
    )
};

